import React, { useEffect } from "react";
import { Tabel, DropDown, DropDownMenu, Modal, FilterWraper } from "../core";
import DeleteModal from "../components/DeleteModal";
import { reducer, initialState } from "../hooks/modalReducer";
import { Link } from "react-router-dom";
import { Menu, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { deleteSizer, getSizer } from "../redux/Action/Sizer/sizer";
import { getCompanyId } from "../helper/utils/companyId";
import SizerEditForm from "../components/SizerEditForm";
const columns = [
  {
    title: "Sizer Name",
    dataIndex: "sizer_name",
    width: 150,
  },
  {
    title: "Address",
    dataIndex: "address_sizer",
    width: "150px",
  },
  {
    title: "Phone Number",
    dataIndex: "phone_no_sizer",
    width: 150,
  },
  {
    title: "NTN",
    dataIndex: "ntn_sizer",
    width: 150,
  },
  {
    title: "STRN",
    dataIndex: "strn_sizer",
    width: 150,
  },
  {
    title: "Action",
    dataIndex: "action",
    width: 150,
    render: (text, record, index) => (
      <DropDown
        overlay={<MenuCompo index={index} record={record} />}
        record={record}
      />
    ),
  },
];
const SizerList = () => {
  const sizerList = useSelector((state) => state.sizer.sizer);
  const { token } = useSelector((state) => state.auth);
  const dispatchtoAction = useDispatch();
  const [SizerRecord, setSizerRecord] = React.useState(null);

  useEffect(() => {
    const companyId = getCompanyId();
    if (companyId && token) {
      dispatchtoAction(getSizer(companyId, token));
    }
  }, [dispatchtoAction, token]);

  React.useEffect(() => {
    setSizerRecord(sizerList);
  }, [sizerList]);
  const changeInput = (e) => {
    let sizerName = e.target.value;

    const filteredSizerArray = sizerList.filter((record) => {
      return record.sizer_name.indexOf(sizerName) > -1;
    });
    setSizerRecord(filteredSizerArray);
  };
  return (
    <FilterWraper range={false} inpputChange={changeInput} dropDown={false}>
      <Tabel columns={columns} data={SizerRecord ? SizerRecord : []} />
    </FilterWraper>
  );
};
const MenuCompo = ({ record }) => {
  const { token } = useSelector((state) => state.auth);
  const [form] = Form.useForm();
  console.log(record);
  const dispatchtoAction = useDispatch();
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const [SizerId, setSizerId] = React.useState(null);
  const company_id = getCompanyId();
  const onCreate = () => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };
  const onCancel = () => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };
  let Error = useSelector((state) => state.errorReducer);
  console.log(SizerId);
  const delete_func = () => {
    console.log(SizerId);
    dispatchtoAction(deleteSizer(SizerId.id, company_id, token));
    if (Error.id === "DELETE_SIZER_SUCCESS") {
      onCancel();
    }
  };

  function menuClickHandler({ item, key }) {
    setSizerId({ id: item.props.id });
    return key === "delete_buyer"
      ? dispatch({
          type: "MODAL_VIEW",
          payload: { flag: true, modal_name: key },
        })
      : key === "edit"
      ? dispatch({
          type: "MODAL_VIEW",
          payload: { flag: true, modal_name: key },
        })
      : null;
  }

  // function onClick({ key, item }) {}

  return (
    <>
      {state.modal_name === "delete_buyer" ? (
        <Modal
          closable={true}
          footer={false}
          visible={state.visible}
          maxwidth="550px"
          tittle="Are You Sure you want to delete this record"
        >
          <DeleteModal
            id_to_delete={SizerId}
            onCancel={onCancel}
            delete_func={delete_func}
          />
        </Modal>
      ) : state.modal_name === "edit" ? (
        <Modal
          closable={true}
          footer={false}
          visible={state.visible}
          onCreate={onCreate}
          tittle=" Update Sizer Information"
          maxwidth="589px"
        >
          <SizerEditForm
            SizerId={SizerId}
            onCreate={onCreate}
            onCancel={onCancel}
            form={form}
          />
        </Modal>
      ) : null}

      <DropDownMenu onClick={menuClickHandler}>
        <Menu.Item key="delete_buyer" id={record.sizer_id} color="blue">
          Delete
        </Menu.Item>
        <Menu.Item key="view">
          <Link to={`/sizer-inner/${record.sizer_id}`}>View</Link>
        </Menu.Item>
        <Menu.Item key={`edit`} id={record.sizer_id}>
          Edit
        </Menu.Item>
      </DropDownMenu>
    </>
  );
};
export default SizerList;
